"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnuitySaaSValidationUtils = void 0;
var Validator_1 = require("../../common/Validator");
var ValidationUtils_1 = require("../../ValidationUtils");
var AnnuitySaaSValidationUtils = /** @class */ (function () {
    function AnnuitySaaSValidationUtils() {
    }
    AnnuitySaaSValidationUtils.isValidPrimaryAnnuitantDOB = function (dob, productType, productCode, contractState) {
        var specObj = Validator_1.Validator.fetchSpecObjectFromSpecs(productType, productCode, contractState);
        if (!specObj) {
            return ValidationUtils_1.ValidationUtils.getGenericProductSpecError();
        }
        var _a = specObj.specs, minAnnuitantAge = _a.minAnnuitantAge, maxAnnuitantAge = _a.maxAnnuitantAge;
        var tooYoung = ValidationUtils_1.ValidationUtils.isYoungerThanAge(dob, minAnnuitantAge);
        var tooOld = ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(dob, maxAnnuitantAge);
        if (tooYoung || tooOld) {
            return {
                isValid: false,
                message: "Must be between ".concat(minAnnuitantAge, " and ").concat(maxAnnuitantAge, " years old")
            };
        }
        return { isValid: true };
    };
    AnnuitySaaSValidationUtils.isValidPurchaseAmount = function (purchaseAmount, productType, productCode, contractState) {
        var specObj = Validator_1.Validator.fetchSpecObjectFromSpecs(productType, productCode, contractState);
        if (!specObj) {
            return ValidationUtils_1.ValidationUtils.getGenericProductSpecError();
        }
        var _a = specObj.specs, minInitialTranche = _a.minInitialTranche, maxLifetimePremium = _a.maxLifetimePremium;
        if (purchaseAmount < minInitialTranche || purchaseAmount > maxLifetimePremium) {
            return { isValid: false, message: "Purchase amount must be between ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(minInitialTranche), " and ").concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(maxLifetimePremium)) };
        }
        return { isValid: true };
    };
    AnnuitySaaSValidationUtils.isValidLivesValue = function (livesValue, ownerType) {
        if (ownerType !== 'individual' && livesValue !== 'Single-Life') {
            return { isValid: false, message: 'Lives must be Single-Life for non-natural owner' };
        }
        return { isValid: true };
    };
    AnnuitySaaSValidationUtils.isValidMarketTypeValue = function (marketValue, ownerType) {
        if (ownerType !== 'individual' && marketValue !== 'Non-Qualified') {
            return { isValid: false, message: 'Market Type must be Non-Qualified for non-natural owner' };
        }
        return { isValid: true };
    };
    return AnnuitySaaSValidationUtils;
}());
exports.AnnuitySaaSValidationUtils = AnnuitySaaSValidationUtils;
